import { useCallback, useMemo } from 'react';
import { CustomReportParamTypes } from '../../../shared/customReports/constants';
import { getParamNamesForQuery } from '../../../shared/customReports/helpers';

export const useVerifyQueryLogic = ({
  formik,
  verifyParamOptionsQuery,
  setOpenForSubmit,
}) => {
  const isQueryType = useMemo(
    () => formik.values.type === CustomReportParamTypes.query,
    [formik]
  );

  const optionsQueryParams = useMemo(
    () => formik.values.query ? getParamNamesForQuery(formik.values.query) : [],
    [formik]
  );

  const onVerifySuccess = useCallback(() => {
    formik.handleSubmit();
    setOpenForSubmit?.(false);
  }, [formik, setOpenForSubmit]);

  const onVerifyFailure = useCallback(() => {
    formik.setFieldTouched('query', true, false);
    formik.setFieldError('query', 'Invalid Query');
    setOpenForSubmit?.(false);
  }, [formik, setOpenForSubmit]);

  const verifyQuery = useCallback((params, { isOpenForSubmit } = {}) => {
    verifyParamOptionsQuery({
      query: formik.values.query,
      ...(params ? { params } : {}),
      onSuccess: isOpenForSubmit ? onVerifySuccess : null,
      onFailure: onVerifyFailure,
    });
  }, [
    formik,
    verifyParamOptionsQuery,
    onVerifySuccess,
    onVerifyFailure,
  ]);

  return {
    verifyQuery, isQueryType, optionsQueryParams,
  };
};
